export const getInitialState = (): any => ({
  uploadDatasetData: {},
  uploadDatasetStatus: 0
});
